import React from 'react';
import { Tabs, Typography, Card, Button, Row, Col, Modal, Form, Input } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import InspectorForm from './Form';
import InspectorProfessionList from '../../inspector-professions/views/List';
import LeaveList from '../../leaves/views/List';
import InspectorMeasuringInstrumentInventory from '../components/InspectorMeasuringInstrumentInventory';
import { getInspector, updateInspector } from '../services/inspectorService';
import { Mail02Icon } from 'hugeicons-react';
import { openNotification, hasRole } from '../../../utils';
export default function InspectorDetail(){
  const { id } = useParams();
  const [referenceId, setReferenceId] = React.useState<number>();
  const [inspector, setInspector] = React.useState<any>();
  const [emailModalVisible, setEmailModalVisible] = React.useState(false);
  const [passwordModalVisible, setPasswordModalVisible] = React.useState(false);
  const [emailForm] = Form.useForm();
  const [passwordForm] = Form.useForm();
  const isAdmin = React.useMemo(() => hasRole('ADMIN'), []);
  const loadInspector = React.useCallback(() => {
    getInspector(Number(id)).then((d) => {
      setInspector(d);
      setReferenceId(d?.account?.id);
    });
  }, [id]);
  const navigate = useNavigate();
  React.useEffect(() => { loadInspector(); }, [loadInspector]);
  const handleEmailSubmit = async (values: any) => {
    try {
      await updateInspector(Number(id), { email: values.email });
      openNotification('success', 'Başarılı', 'E-posta güncellendi');
      setEmailModalVisible(false);
      emailForm.resetFields();
      loadInspector();
    } catch (e: any) {
      const message = e?.message || 'E-posta güncellenemedi';
      openNotification('error', 'Hata', message);
    }
  };
  const handlePasswordSubmit = async (values: any) => {
    try {
      await updateInspector(Number(id), { password: values.newPassword, passwordRepeat: values.confirmPassword });
      openNotification('success', 'Başarılı', 'Şifre güncellendi');
      setPasswordModalVisible(false);
      passwordForm.resetFields();
    } catch (e: any) {
      const message = e?.message || 'Şifre güncellenemedi';
      openNotification('error', 'Hata', message);
    }
  };
  const items = [
    { key: 'tab0', label: 'Kişisel Bilgiler', children: <InspectorForm id={Number(id)} onSuccess={() => navigate('/settings/inspectors')} /> },
    { key: 'tab1', label: 'Meslek Bilgileri', children: <InspectorProfessionList referenceId={referenceId} /> },
    { key: 'tab2', label: 'Ölçüm Cihazları', children: <InspectorMeasuringInstrumentInventory referenceId={referenceId} /> },
    { key: 'tab3', label: 'İzin Bilgileri', children: <LeaveList referenceId={referenceId} /> },
  ];
  return (
    <>
      <Card className='br-30px' style={{ marginBottom: 16 }}>
        <Row align='middle' justify='space-between' gutter={[16, 16]}>
          <Col flex="auto">
            <Typography.Title level={4} style={{ margin: 0 }}>
              {(inspector?.account?.firstName || '') + ' ' + (inspector?.account?.lastName || '')}
            </Typography.Title>
            <Typography.Text style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Mail02Icon style={{ width: 18, height: 18 }} />
              <span>{inspector?.account?.email || '—'}</span>
              {isAdmin && (
                <Button
                  style={{ paddingLeft: 5, color: 'black' }}
                  type='link'
                  onClick={() => {
                    emailForm.setFieldsValue({ email: inspector?.account?.email });
                    setEmailModalVisible(true);
                  }}
                >
                  Değiştir
                </Button>
              )}
            </Typography.Text>
          </Col>
          {isAdmin && (
            <Col>
              <Button type='primary' onClick={() => setPasswordModalVisible(true)}>
                Şifre Değiştir
              </Button>
            </Col>
          )}
        </Row>
      </Card>
      <Card className='br-30px' >
        <Tabs
          items={items}
          tabBarExtraContent={{
            right: (
              <Button onClick={() => navigate('/settings/inspectors')} className='d-button action-button'>
                Geri
              </Button>
            ),
          }}
        />
      </Card>
      <Modal
        title='E-posta değiştir'
        visible={emailModalVisible}
        onCancel={() => setEmailModalVisible(false)}
        footer={null}
        width={400}
        style={{ borderRadius: '10px' }}
      >
        <Form form={emailForm} onFinish={handleEmailSubmit} layout='vertical'>
          <Form.Item
            label='Yeni E-Posta'
            name='email'
            rules={[{ required: true, message: 'E-Posta boş bırakılamaz', type: 'email' }]}
          >
            <Input className='d-input d-input-form' />
          </Form.Item>
          <Form.Item>
            <Row justify={'center'}>
              <Button className='d-button dark-button width-auto' type='primary' htmlType='submit' block>Değiştir</Button>
            </Row>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title='Şifre değiştir'
        visible={passwordModalVisible}
        onCancel={() => setPasswordModalVisible(false)}
        footer={null}
        width={450}
        style={{ borderRadius: '10px' }}
      >
        <Form form={passwordForm} onFinish={handlePasswordSubmit} layout='vertical'>
          <Form.Item
            label='Yeni Şifre'
            name='newPassword'
            rules={[
              { required: true, message: 'Yeni şifre boş bırakılamaz' },
              {
                validator: (_, value) => {
                  const errors: string[] = [];
                  if (!value) {
                    return Promise.reject(new Error('Şifre boş bırakılamaz!'));
                  }
                  if (value.length < 8) {
                    errors.push('Şifre en az 8 karakter olmalıdır!');
                  }
                  if (!/[0-9]/.test(value)) {
                    errors.push('En az bir sayı içermelidir!');
                  }
                  if (errors.length > 0) {
                    return Promise.reject(new Error(errors.join('\n')));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input.Password className='d-input d-input-form' />
          </Form.Item>
          <Form.Item
            label='Yeni Şifre Tekrarı'
            name='confirmPassword'
            dependencies={['newPassword']}
            rules={[
              { required: true, message: 'Yeni şifre (tekrar) boş bırakılamaz' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Şifreler uyuşmuyor.'));
                },
              }),
            ]}
          >
            <Input.Password className='d-input d-input-form' />
          </Form.Item>
          <Form.Item>
            <Row justify={'center'}>
              <Button className='d-button dark-button width-auto' type='primary' htmlType='submit' block>Değiştir</Button>
            </Row>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
